module.exports = __webpack_public_path__ + "img/custom-item2-7.9c816d6.png";